import { ICompany } from '@collections/companies/interfaces/company.interface';
import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ICategory } from '@collections/categories/interfaces';
import { StandService } from 'app/stand/stand.service';
import { Observable, take } from 'rxjs';
import { GetCategoryUrlPipe } from '../../../shared/pipes/get-category-url.pipe';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'stand-footer',
    templateUrl: './stand-footer.component.html',
    styleUrls: ['./stand-footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatIcon, RouterLink, AsyncPipe, GetCategoryUrlPipe]
})
export class StandFooterComponent {


  $company: Observable<ICompany>;

  categories: ICategory[];

  constructor(
    public standService: StandService
  ) {
    this.$company = this.standService.getCurrentCompany();

    this.$company
    .pipe(take(1))
    .subscribe(c => {
      this.setCategories(c);

    });

  }

  setCategories(company: ICompany): void {
    if (company) {
      const categories: ICategory[] = [];

      const sortedCats = [...company.categories].sort((a, b) => a.level - b.level);
      for (const cat of sortedCats) {
        let resCat = categories.find((v) => {
          const parentPath = cat.parent.path;
          const path = cat.level == 1 ? parentPath : parentPath.substring(0, parentPath.lastIndexOf('/'));
          return v.path === path;
        });
        if (!resCat) {
          resCat = Object.assign({}, cat.parent);
          resCat.childs = [cat];
          categories.push(resCat);
        } else {
          resCat.childs.push(cat);
        }
      }
      this.categories = categories;
    }
  }

}
